// extracted by mini-css-extract-plugin
export default {"card":"CarInitialInfo_card__ikYi4","header":"CarInitialInfo_header__McB-A"};